/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggest_Workout_PainInputs */

const en_us2_coach_suggest_workout_pain = /** @type {(inputs: Coach_Suggest_Workout_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I just felt some pain`)
};

const pt_br2_coach_suggest_workout_pain = /** @type {(inputs: Coach_Suggest_Workout_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senti uma dor agora`)
};

const es_419_coach_suggest_workout_pain = /** @type {(inputs: Coach_Suggest_Workout_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acabo de sentir un dolor`)
};

const pt_pt2_coach_suggest_workout_pain = /** @type {(inputs: Coach_Suggest_Workout_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senti agora uma dor`)
};

const fr_fr2_coach_suggest_workout_pain = /** @type {(inputs: Coach_Suggest_Workout_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je viens d'avoir mal`)
};

const de_de2_coach_suggest_workout_pain = /** @type {(inputs: Coach_Suggest_Workout_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe gerade Schmerzen gespürt`)
};

const it_it2_coach_suggest_workout_pain = /** @type {(inputs: Coach_Suggest_Workout_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho appena sentito un dolore`)
};

/**
* | output |
* | --- |
* | "I just felt some pain" |
*
* @param {Coach_Suggest_Workout_PainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggest_workout_pain = /** @type {((inputs?: Coach_Suggest_Workout_PainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggest_Workout_PainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggest_workout_pain(inputs)
	if (locale === "es-419") return es_419_coach_suggest_workout_pain(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggest_workout_pain(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggest_workout_pain(inputs)
	if (locale === "de-DE") return de_de2_coach_suggest_workout_pain(inputs)
	if (locale === "it-IT") return it_it2_coach_suggest_workout_pain(inputs)
	return en_us2_coach_suggest_workout_pain(inputs)
});
export { coach_suggest_workout_pain as "coach.suggest_workout_pain" }